// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup

/** The combo page triggers of the featured petition step: `v1` acts on Skip, `v2` on a share redirect. */
type FeaturedTrigger = 'skip' | 'share';

/**
 * Module-level latch, never reset: the triggers already used in this page load. A page the browser restores
 * from its back-forward cache keeps it, so Back to the combo page does not show the step (or, in
 * `fake_control`, track it) a second time. A full reload resets it; the exposure cap then drops the signer.
 * `fake_control` latches each trigger on its own, so each mirrors the arm that acts on it.
 */
const usedTriggers = new Set<FeaturedTrigger>();

/** `true` on the trigger's first use in this page load, which it records */
export function claimFeaturedTrigger(trigger: FeaturedTrigger): boolean {
	if (usedTriggers.has(trigger)) return false;
	usedTriggers.add(trigger);
	return true;
}

/** Whether the trigger was used in this page load, without recording a use */
export function isFeaturedTriggerUsed(trigger: FeaturedTrigger): boolean {
	return usedTriggers.has(trigger);
}
